(function() {
  var __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  define('tlhComponentsS3Uploader',['angular'], function() {
    'use strict';
    return angular.module('tlhComponentsS3Uploader', []).component('tlhS3Uploader', {
      bindings: {
        options: '<'
      },
      transclude: true,
      template: '<div ng-transclude></div>',
      controller: [
        '$scope', '$filter', function($scope, $filter) {
          var fileIsValid, fileUploaded, getFileKey, getFormData, getUploadedFiles, getXhr, input, isFileDuplication, onInput, removeUploadedFiles, uploadComplete, uploadFileAborted, uploadFileFailed, uploadFileProgress, uploadNextFile, validFileSize, validFileType, vm, _base, _base1, _base2, _base3, _base4, _base5, _base6, _base7;
          vm = this;
          if (vm.options == null) {
            vm.options = {};
          }
          if ((_base = vm.options).s3Config == null) {
            _base.s3Config = {};
          }
          if ((_base1 = vm.options).multiple == null) {
            _base1.multiple = false;
          }
          if ((_base2 = vm.options).allowedTypes == null) {
            _base2.allowedTypes = ['*'];
          }
          if ((_base3 = vm.options).preview == null) {
            _base3.preview = true;
          }
          if ((_base4 = vm.options).fileMaxSize == null) {
            _base4.fileMaxSize = 0;
          }
          if ((_base5 = vm.options).maxFiles == null) {
            _base5.maxFiles = 0;
          }
          if ((_base6 = vm.options).timestamp == null) {
            _base6.timestamp = false;
          }
          if ((_base7 = vm.options).removeUploadedFiles == null) {
            _base7.removeUploadedFiles = true;
          }
          vm.inputFiles = [];
          vm.isUploading = false;
          vm.uploadProgress = 0;
          vm.uploadTotalSize = 0;
          vm.currentlyLoaded = 0;
          input = document.createElement('input');
          input.type = 'file';
          input.multiple = vm.options.multiple;
          input.accept = vm.options.allowedTypes;
          input.onchange = function() {
            return onInput(this.files);
          };
          onInput = function(inputFiles) {
            var inputFile, _base8, _i, _len;
            for (_i = 0, _len = inputFiles.length; _i < _len; _i++) {
              inputFile = inputFiles[_i];
              if (fileIsValid(inputFile)) {
                vm.inputFiles.push(inputFile);
              }
            }
            if (typeof (_base8 = vm.options).onInput === "function") {
              _base8.onInput(vm.inputFiles, inputFiles);
            }
            if (!vm.options.preview) {
              vm.launchUpload();
            }
            return $scope.$apply();
          };
          fileIsValid = function(file) {
            var error, _base8, _base9;
            error = null;
            if (!validFileType(file)) {
              error = 'Le type de fichier de ' + file.name + ' n\'est pas accepté';
            } else if (!validFileSize(file)) {
              error = 'La taille du fichier ' + file.name + ' est trop élevée (maximum ' + $filter('filesize')(vm.options.fileMaxSize) + ')';
            } else if (isFileDuplication(file)) {
              error = 'Le fichier ' + file.name + ' est déjà présent dans la file d\'attente';
            } else {
              error = typeof (_base8 = vm.options).fileValidationError === "function" ? _base8.fileValidationError(file) : void 0;
            }
            if (error) {
              if (typeof (_base9 = vm.options).onFileInvalid === "function") {
                _base9.onFileInvalid(error, file);
              }
            }
            return !error;
          };
          validFileType = function(file) {
            var _ref;
            return vm.options.allowedTypes[0] === '*' || (_ref = file.type, __indexOf.call(vm.options.allowedTypes, _ref) >= 0);
          };
          validFileSize = function(file) {
            return vm.options.fileMaxSize > 0 && file.size < vm.options.fileMaxSize;
          };
          isFileDuplication = function(file) {
            var duplication, inputFile, _i, _len, _ref;
            duplication = false;
            _ref = vm.inputFiles;
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
              inputFile = _ref[_i];
              if (inputFile.name === file.name && inputFile.type === file.type && inputFile.size === file.size) {
                duplication = true;
                break;
              }
            }
            return duplication;
          };
          vm.browseFiles = function() {
            return input.click();
          };
          vm.removeInputFile = function(file) {
            return vm.inputFiles.splice(vm.inputFiles.indexOf(file), 1);
          };
          vm.emptyQueue = function() {
            vm.inputFiles = [];
            vm.uploadProgress = 0;
            return vm.currentlyLoaded = 0;
          };
          vm.cancelUpload = function() {
            var file, _base8, _i, _len, _ref;
            if (typeof (_base8 = vm.options).onCancel === "function") {
              _base8.onCancel();
            }
            _ref = vm.inputFiles;
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
              file = _ref[_i];
              if (!file.url && file.cancelUpload) {
                file.cancelUpload();
              }
            }
            return vm.isUploading = false;
          };
          vm.launchUpload = function() {
            var file, _i, _len, _ref;
            if (!vm.isUploading && vm.inputFiles.length > 0) {
              vm.options.onLaunch();
              vm.isUploading = true;
              vm.uploadTotalSize = 0;
              vm.currentlyLoaded = 0;
              _ref = vm.inputFiles;
              for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                file = _ref[_i];
                if (file.url) {
                  vm.currentlyLoaded += file.size;
                }
                vm.uploadTotalSize += file.size;
              }
              return vm.uploadFile(vm.inputFiles[0], 0);
            }
          };
          vm.uploadFile = function(file, fileIndex) {
            var formData, xhr;
            if (file.url) {
              return uploadNextFile(fileIndex);
            } else {
              file.isUploading = true;
              file.error = false;
              formData = getFormData(file);
              xhr = getXhr(file, fileIndex);
              return xhr.send(formData);
            }
          };
          getFormData = function(file) {
            var config, formData;
            formData = new FormData();
            config = vm.options.s3Config;
            formData.append('key', getFileKey(config.keyStart, file.name));
            formData.append('success_action_status', 201);
            formData.append('X-Requested-With', 'xhr');
            formData.append('Content-Type', file.type);
            formData.append('acl', config.acl);
            formData.append('x-amz-credential', config.credential);
            formData.append('x-amz-algorithm', config.algorithm);
            formData.append('x-amz-date', config.date);
            formData.append('x-amz-expires', config.expires);
            formData.append('x-amz-signature', config.signature);
            formData.append('policy', config.policy);
            formData.append("file", file);
            return formData;
          };
          getFileKey = function(start, filename) {
            var key;
            key = start;
            if (vm.options.timestamp) {
              key += Date.now() + '-';
            }
            key += filename;
            return key;
          };
          getXhr = function(file, fileIndex) {
            var error, xhr, _base8;
            xhr = new XMLHttpRequest();
            xhr.upload.onprogress = function(e) {
              return uploadFileProgress(e, file);
            };
            xhr.onerror = function(e) {
              return uploadFileFailed(e, file);
            };
            xhr.onabort = function(e) {
              return uploadFileAborted(e, file);
            };
            xhr.onreadystatechange = function() {
              if (xhr.readyState === XMLHttpRequest.DONE) {
                return fileUploaded(xhr, file, fileIndex);
              }
            };
            try {
              xhr.open('POST', 'https://' + vm.options.s3Config.endpoint + '.amazonaws.com/' + vm.options.s3Config.bucket, true);
            } catch (_error) {
              error = _error;
              if (typeof (_base8 = vm.options).onFileError === "function") {
                _base8.onFileError(error, file, 'Problème de configuration. Veuillez contacter l\'administrateur.');
              }
              file.error = true;
              file.isUploading = false;
              vm.isUploading = false;
              console.log(error);
            }
            file.cancelUpload = function() {
              return xhr.abort();
            };
            return xhr;
          };
          uploadFileProgress = function(e, file) {
            var progress;
            if (e.lengthComputable) {
              file.progress = e.loaded / e.total * 100 | 0;
              progress = Math.round((vm.currentlyLoaded + e.loaded) / vm.uploadTotalSize * 100);
              if (progress > 99) {
                progress = 100;
              }
              return $scope.$apply(function() {
                return vm.uploadProgress = progress;
              });
            }
          };
          uploadFileFailed = function(e, file) {
            var _base8;
            if (typeof (_base8 = vm.options).onFileError === "function") {
              _base8.onFileError(e, file, 'Erreur lors de l\'envoi du fichier ' + file.name);
            }
            file.error = true;
            file.isUploading = false;
            return console.log(e);
          };
          uploadFileAborted = function(e, file) {
            var _base8;
            return typeof (_base8 = vm.options).onFileAbort === "function" ? _base8.onFileAbort(file) : void 0;
          };
          fileUploaded = function(xhr, file, fileIndex) {
            var url, _base8, _base9;
            file.isUploading = false;
            if (xhr.status === 201) {
              url = xhr.responseXML.getElementsByTagName("Location")[0].childNodes[0].nodeValue;
              if (url) {
                file.url = url;
              }
              if (typeof (_base8 = vm.options).onFileUploaded === "function") {
                _base8.onFileUploaded(file);
              }
            } else if (xhr.status !== 0) {
              if (typeof (_base9 = vm.options).onFileError === "function") {
                _base9.onFileError(null, file, 'Erreur lors de l\'envoi du fichier ' + file.name);
              }
              file.error = true;
              console.log('XHR status: ' + xhr.status);
              console.log('XHR response: ' + xhr.responseText);
            }
            if (xhr.status !== 0) {
              vm.currentlyLoaded += file.size;
              return uploadNextFile(fileIndex);
            }
          };
          uploadNextFile = function(fileIndex) {
            fileIndex++;
            if (vm.inputFiles[fileIndex]) {
              return vm.uploadFile(vm.inputFiles[fileIndex], fileIndex);
            } else {
              return uploadComplete();
            }
          };
          uploadComplete = function() {
            var uploadedFiles, _base8;
            uploadedFiles = getUploadedFiles(vm.inputFiles);
            if (typeof (_base8 = vm.options).uploadComplete === "function") {
              _base8.uploadComplete(uploadedFiles, vm.inputFiles);
            }
            vm.isUploading = false;
            if (vm.options.removeUploadedFiles) {
              removeUploadedFiles(uploadedFiles);
            }
            return vm.uploadProgress = 0;
          };
          getUploadedFiles = function(files) {
            var file, uploadedFiles, _i, _len;
            uploadedFiles = [];
            for (_i = 0, _len = files.length; _i < _len; _i++) {
              file = files[_i];
              if (file.url) {
                uploadedFiles.push(file);
              }
            }
            return uploadedFiles;
          };
          removeUploadedFiles = function(uploadedFiles) {
            var file, _i, _len, _results;
            _results = [];
            for (_i = 0, _len = uploadedFiles.length; _i < _len; _i++) {
              file = uploadedFiles[_i];
              _results.push(vm.removeInputFile(file));
            }
            return _results;
          };
        }
      ]
    });
  });

}).call(this);

//# sourceMappingURL=s3Uploader.js.map
;
